var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.974609,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#4081FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9753 31.6419C17.4934 31.6419 16.292 30.4406 16.292 28.9586V18.9919C16.292 17.51 17.4934 16.3086 18.9753 16.3086H25.2306C25.9496 16.3086 26.6385 16.5971 27.1429 17.1095L28.9376 18.9327C29.4317 19.4347 29.7087 20.1108 29.7087 20.8151V28.9586C29.7087 30.4406 28.5073 31.6419 27.0253 31.6419H18.9753ZM19.167 22.2982C18.77 22.2982 18.4482 22.62 18.4482 23.0169C18.4482 23.4139 18.77 23.7357 19.167 23.7357H21.0837C21.4806 23.7357 21.8024 23.4139 21.8024 23.0169C21.8024 22.62 21.4806 22.2982 21.0837 22.2982H19.167ZM18.4482 25.8919C18.4482 25.495 18.77 25.1732 19.167 25.1732H23.0003C23.3973 25.1732 23.7191 25.495 23.7191 25.8919C23.7191 26.2889 23.3973 26.6107 23.0003 26.6107H19.167C18.77 26.6107 18.4482 26.2889 18.4482 25.8919ZM19.167 28.0482C18.77 28.0482 18.4482 28.37 18.4482 28.7669C18.4482 29.1639 18.77 29.4857 19.167 29.4857H26.8337C27.2306 29.4857 27.5524 29.1639 27.5524 28.7669C27.5524 28.37 27.2306 28.0482 26.8337 28.0482H19.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.fda7b95b4675480423a8b64a5af6b301.svg";
export { ForwardRef as ReactComponent };